import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col, Form, Button, Badge } from 'react-bootstrap';

const DetalleCuentaPanel = ({ selectedAccount, onEdit, onDelete }) => {
  return (
    <Card className="h-100 shadow-sm border-0 bg-light">
      <Card.Body>
        {selectedAccount ? (
          <div>
            <div className="d-flex justify-content-between align-items-start mb-4">
              <div>
                <h4 className="mb-1 text-primary">{selectedAccount.vCodigoCuenta}</h4>
                <h5 className="text-secondary">{selectedAccount.vNombreCuenta}</h5>
              </div>
              <Badge bg={selectedAccount.iTipoNivelCuenta?.toString() === '3' ? 'success' : (selectedAccount.iTipoNivelCuenta?.toString() === '2' ? 'primary' : 'secondary')} className="px-3 py-2">
                {selectedAccount.iTipoNivelCuenta?.toString() === '3' ? 'Cuenta de Detalle' : (selectedAccount.iTipoNivelCuenta?.toString() === '2' ? 'Cuenta Mayor / Agrupadora' : 'Cuenta Título')}
              </Badge>
            </div>

            <Row className="mb-3">
              <Col sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Código de Cuenta</Form.Label>
                  <Form.Control type="text" value={selectedAccount.vCodigoCuenta} readOnly />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Naturaleza</Form.Label>
                  <Form.Control
                    type="text"
                    value={selectedAccount.vNaturaleza === 'D' ? 'Deudora' : 'Acreedora'}
                    readOnly
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Nombre de la Cuenta</Form.Label>
                  <Form.Control type="text" value={selectedAccount.vNombreCuenta} readOnly />
                </Form.Group>
              </Col>

              {selectedAccount.idCatCuentaContableSAT && (
                <Col sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold text-success">Vinculación SAT</Form.Label>
                    <Form.Control
                      type="text"
                      value={`${selectedAccount.vCodigoCuentaSAT} - ${selectedAccount.vNombreCuentaSAT}`}
                      readOnly
                      className="bg-light"
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>

            <div className="mt-4 pt-3 border-top text-end">
              <Button variant="danger" className="me-2" onClick={() => onDelete && onDelete(selectedAccount)}>
                Eliminar Cuenta
              </Button>
              <Button variant="primary" onClick={() => onEdit && onEdit(selectedAccount)}>
                Editar Cuenta
              </Button>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
            <div className="mb-3" style={{ fontSize: '3rem' }}>📁</div>
            <h5>Selecciona una cuenta</h5>
            <p>Haz clic en una cuenta del árbol a la izquierda para ver y editar sus detalles.</p>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

DetalleCuentaPanel.propTypes = {
  selectedAccount: PropTypes.shape({
    vCodigoCuenta: PropTypes.string,
    vNombreCuenta: PropTypes.string,
    iTipoNivelCuenta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vNaturaleza: PropTypes.string,
    idCatCuentaContableSAT: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vCodigoCuentaSAT: PropTypes.string,
    vNombreCuentaSAT: PropTypes.string
  }),
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default DetalleCuentaPanel;
